<template>
  <div class="signup-container">
    <form @submit.prevent="handleSignup" class="signup-form">
      <input v-model="name" placeholder="名前" required />
      <input v-model="age" type="number" placeholder="年齢" required />
      <select v-model="gender" required>
        <option value="">性別を選択</option>
        <option value="male">男性</option>
        <option value="female">女性</option>
      </select>
      <input v-model="dob" type="date" placeholder="生年月日" required />
      <input v-model="password" type="password" placeholder="パスワード" required />
      <button type="submit">サインアップ</button>
    </form>
    <p class="message">{{ message }}</p>
    <p>アカウントをお持ちですか？ <router-link to="/login">ログイン</router-link></p>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { useStore } from 'vuex'; // Vuexストアのインポート

export default {
  name: 'UserSignup',
  setup() {
    const router = useRouter();
    const store = useStore(); // Vuexストアのインスタンスを取得
    const name = ref('');
    const age = ref('');
    const gender = ref('');
    const dob = ref('');
    const password = ref('');
    const message = ref('');

    const handleSignup = async () => {
      try {
        const response = await fetch('http://172.16.80.71:5000/signup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: name.value,
            age: age.value,
            gender: gender.value,
            dob: dob.value,
            password: password.value,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          message.value = data.message; // サインアップ成功メッセージ
          store.dispatch('login', name.value); // Vuexストアに認証状態を設定
          router.push('/productlist'); // 成功時に /productlist にリダイレクト
        } else {
          message.value = data.message; // エラーメッセージ
        }
      } catch (error) {
        message.value = 'エラーが発生しました'; // ネットワークエラーなど
      }
    };

    return {
      name,
      age,
      gender,
      dob,
      password,
      message,
      handleSignup,
    };
  },
};
</script>

<style>
.signup-container {
  max-width: 400px;
  margin: auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}

.signup-form {
  display: flex;
  flex-direction: column;
}

.signup-form input,
.signup-form select {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.signup-form button {
  padding: 10px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.signup-form button:hover {
  background-color: #0056b3;
}

.message {
  color: #28a745;
  margin-top: 10px;
}

p {
  text-align: center;
}
</style>